import { render, staticRenderFns } from "./TableDeclReadOnly.vue?vue&type=template&id=53a338ac&scoped=true&"
import script from "./TableDeclReadOnly.vue?vue&type=script&lang=js&"
export * from "./TableDeclReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./TableDeclReadOnly.vue?vue&type=style&index=0&id=53a338ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a338ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VAvatar,VBtn,VChip,VIcon,VImg,VProgressCircular})
